$(function () {
    "use strict";

    $(document).on('ready', function () {
        var $callToPayModal = $('#call-to-pay-modal');

        if ($callToPayModal.length) {
            Modal.openModal('call-to-pay-modal');

            $callToPayModal.find('.call-to-pay__link').on('click', function() {
                setCookie('nvst_fwt_s', 1, 1);
                Modal.closeModal('call-to-pay-modal');
                $('.call-to-pay__header').addClass('call-to-pay__header_shown');
            });
        }
    });
});